<template>
	<div class="flex flex-col min-h-screen">
		<OrganismHeaderBar
			is-sales-header
			:phone-number="phoneNumber"
			:phone-link="phoneLink"
			:home-link="homeLink"
		/>

		<div
			v-if="breadcrumbs"
			class="container relative mt-8"
		>
			<LazyAtomBreadcrumbs
				class="text-functional-size-sm"
				:breadcrumbs="breadcrumbs"
			/>
		</div>

		<main :class="['relative grow', classNames]">
			<slot />
		</main>

		<footer
			class="relative pt-6 pb-10 text-paragraph-size-md flex flex-col items-center gap-24 justify-center bg-gray-200"
		>
			<p class="text-gray-400 text-paragraph-size-sm text-center">
				© 2023 - {{ getYear() }} <span class="mx-2.5" /> {{ baseCompanyData.legalName }}
				<span class="mx-6">|</span>
				{{ fitCompanyData.name }} is een handelsnaam van {{ baseCompanyData.legalName }}
			</p>
		</footer>
	</div>
	<OrganismNotifications />
	<OrganismDialogs />
</template>

<script lang="ts" setup>
import { phoneNumber } from '#base/core/consts/companyData';
import { homeLink, phoneLink } from '#fit/core/consts/links';
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import { getYear } from '#base/helpers/dateHelpers';
import * as baseCompanyData from '#base/core/consts/companyData';
import * as fitCompanyData from '#fit/core/consts/companyData';

const {
	breadcrumbs,
	class: classNames,
} = defineProps<{
	breadcrumbs?: BreadcrumbsType;
	class?: string | object | string[];
}>();

useExternalScripts();
</script>
